import getNative from './_getNative.js'
import root from './_root.js'

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map')

export default Map
